import AbmBeneficios from "../../components/textos/AbmBeneficios/AbmBeneficios";

export const configAbm = {
    urls: [
        "/Texto/GetByIdTipoTexto/1?Pagina=1&RegistrosPorPagina=-1", // GET
        "/Texto", // POST 
        "/Texto", // PUT
        "/Texto" // DELETE
    ],
    grid: {
        columnConfig: ["id","nombre", "descripcion"], // cuidado con el orden de los strings
        searchField: ["nombre", "id", "descripcion"]
    },
    Abm: AbmBeneficios,
    textSize: 10
}
const ColumnBaseNewComplete = [
    {
      type: "select-boolean",
      name:"",
      width: 300
    }, 
    
    {
      type: "string", 
      name : "descripcion",
      width: 300
    },
    {
      type: "number", 
      name : "id",
      width: 300
    }, 
    {
      type: "string", 
      name : "nombre", 
      width: 300
    }
]; 
const ColumnBaseNew = [
    
    {
      type: "string", 
      name : "descripcion", 
      width: 300, 
    },
    
    {
      type: "number", 
      name : "id", 
      width: 300
    }, 
    {
      type: "string", 
      name : "nombre", 
      width: 300
    }, 
]; 

export const config = {
    data:  [], 
    columnComplete: ColumnBaseNewComplete, 
    column: ColumnBaseNew, 
    paginationView: 13, 
    pagination: true, 
    border: true, 
    borderType: "line",
    width: 900,  
    colWidth: true, 
}